export const AVAILABLE_COLORS = [
  '#FFE5B4', // Peach
  '#FFB6C1', // Light Pink
  '#B0E0E6', // Powder Blue
  '#DDA0DD', // Plum
  '#F0E68C', // Khaki
  '#98FB98', // Pale Green
];

// Trash zone dimensions (must match TrashZone.module.css)
export const TRASH_ZONE_SIZE = {
  width: 180,
  height: 150,
  margin: 20,
};

export const MIN_NOTE_SIZE = { width: 150, height: 100 };
export const DEFAULT_NOTE_SIZE = { width: 200, height: 150 };
